import React from 'react';
import AdminLayout from "./AdminLayout";
import CourseProfile from "../tutor/CourseProfile";

const ViewCourse = () => {
    return (
        <AdminLayout>
            <CourseProfile/>
        </AdminLayout>
    );
};

export default ViewCourse;